import { askInfoModelState } from './askInfoModel';
import { releaseModelState } from './releaseModel';
import { answerModelState } from './answerModel';

const initialState = {
      ...askInfoModelState,
      ...releaseModelState,
      ...answerModelState
    };

export type IInitialState = Readonly<typeof initialState>;

export default initialState;
